import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Modal, Alert, Button} from 'react-bootstrap'
import {uploadUsers, getUsers} from '../action/userActions'

import loading from '../../assets/loading.svg'

class UploadModal extends Component{
    constructor(props){
        super(props)
        this.state ={show : false, file: null}
    }

    render(){

        const Result = (()=>{
            if(this.props.uploadResult){
                return  <table border='1' style={{margin: 'auto'}}>
            <thead>
            <tr>
                    <th>
                    Created
                </th>
                <th>
                    Updated
                </th>
            </tr>
            </thead>
         <tbody>
         <tr>
                    <td>
                        {this.props.uploadResult.created}
                    </td>
                    <td>
                        {this.props.uploadResult.updated}
                    </td>
                </tr>
         </tbody>

             
         
            </table>
            }else{
                return ""
            }

        })

        return <div>
            <Button onClick={()=>{
                this.setState({show: true})
            }}>Upload Users</Button>
            <Modal show={this.state.show}>
                <Modal.Header>
                        Bulk Upload Users
                </Modal.Header>
                <Modal.Body>
                <img hidden={!this.props.loading} style={{width : '100%'}} src={loading } />
                
             
                <div hidden={this.props.loading}>

                <input  type='file' name='users' text='Import Users' onChange={(e)=>{
                    this.setState({file : e.target.files[0]})
                }}  />

                   <Button hidden={!this.state.file} onClick={()=>{
                       this.props.dispatch(uploadUsers(this.state.file))
                   }} >Submit Import File</Button>
               </div>

                   <Result />
               
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={()=>{
                        this.setState({show: false})
                        if(this.props.uploadResult){
                            this.props.dispatch(getUsers())
                        }
                        
                    }}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    }
}

const mapStateToProps = state => (
    {
    loading : state.acct.user.uploadLoading,
    uploadResult : state.acct.user.uploadResult,
    error : state.acct.user.error
  });

export default connect(mapStateToProps)(UploadModal)